<template>
  <div class="content" v-if="stanningLog !== null">
    <h1>{{ stanningLog.title }}</h1>
    <div class="cover-section">
      <div>
        {{ stanningLog.content }}
      </div>
      <div class="row">
        <div class="col-sm-1" v-for="(image, index) in stanningLog.images" :key="index">
          <img :src="image" />
        </div>
      </div>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">기본 정보</h4>
      <card class="text-left">
        <div class="row">
          <label class="col-md-2 col-form-label key">ID</label>
          <label class="col-md-3 col-form-label value">{{ stanningLog.stanningLogId }}{{ stanningLog.categoryName }}</label>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">작성자</label>
          <span class="col-md-10 col-form-label value"
            ><a @click="goUserDetail(stanningLog.userId)">{{ stanningLog.nickname }}({{ stanningLog.userId }})</a></span
          >
        </div>

        <div class="row">
          <label class="col-md-2 col-form-label key">작성일시</label>
          <span class="col-md-10 col-form-label value">{{ stanningLog.regTime }}</span>
        </div>
      </card>
    </div>
    <div class="row actions">
      <base-button class="btn-danger col-md-12" @click="onClickDelete" type="success">삭제</base-button>
    </div>
    <div class="report-section">
      <h4 class="section-title pull-left">신고 내역</h4>
      <card>
        <div class="row">
          <ReportsForContentTableView class="col-12" :reports="reports" />
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { BaseButton, Card } from "@/components/index";
import ReportsForContentTableView from "@/pages/Reports/ReportsForContentTableView";
import { Alert } from "@/util/Alert";
import { formatDateTime } from "@/util/DateUtils";
import { StanningLogCategories } from "@/pages/MyPage/StanningLogCategories";

export default {
  name: "StanningLogDetail",
  components: {
    BaseButton,
    Card,
    ReportsForContentTableView,
  },
  data() {
    return {
      reports: [],
      stanningLog: null,
      stanningLogId: null,
      types: StanningLogCategories,
    };
  },
  mounted: async function () {
    await this.getStanningLog();
  },
  methods: {
    async getStanningLog() {
      try {
        const stanningLogId = this.$route.query.stanningLogId;
        const result = await this.$axios.get(`/stanningLogs/${stanningLogId}`);
        this.stanningLog = result.data.data;
        this.stanningLog.images = this.stanningLog.imageIds
          .split(",")
          .filter((id) => id !== "")
          .map((imageId) => window.Endpoints.imageServerUrl + imageId);

        this.stanningLog.regTime = formatDateTime(this.stanningLog.regTime);
        this.stanningLog.categoryName = this.types
          .map((type) => {
            if (type.type === this.stanningLog.category) {
              return type.name;
            } else {
              return null;
            }
          })
          .filter((type) => type !== null)
          .toString();

        await this.getReports();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getReports() {
      try {
        const result = await this.$axios.get(`/stanningLogs/${this.stanningLog.stanningLogId}/reports`);
        this.reports = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },

    async onClickDelete() {
      if (await Alert.dangerousConfirmCancel("삭제 확인", `${this.stanningLog.title} 덕질기록 을 삭제하시겠습니까?`, "삭제", "취소")) {
        try {
          await this.$axios.delete(`/stanningLogs/${this.stanningLog.stanningLogId}`);
          window.Toast.success("덕질기록이 삭제되었습니다.");
          this.$router.back();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    goUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  text-align: unset;
}

.cover-section {
  .tips {
    img {
      margin-bottom: 30px;
    }
  }
}

.section-title {
  text-decoration: underline;
}

.key {
  font-weight: bold;
}

.actions {
  margin-bottom: 40px;
}

.pointer {
  cursor: pointer;
}
</style>
